<template>
  <div class="page-home">
    <Hplc />
    <Navigation />
  </div>
</template>

<script>
  import Hplc from '@/prerender-pages/components/home/Hplc.vue';
  import Navigation from '@/prerender-pages/components/home/navigation/Navigation.vue';

  export default {
    name: 'PageHome',

    components: {
      Navigation,
      Hplc,
    },
  };
</script>
